const permissions = {
  FULL: "full",
  LIMITED: "limited",
  ACCOUNTADMIN: "accountadmin",
  SUPERADMIN: "superadmin",
} as const;

export default permissions;
